export default __webpack_public_path__ + "static/media/dottedCircle.fa7445d5.svg";